import { render, staticRenderFns } from "./DownLoadButton.vue?vue&type=template&id=278aa863&scoped=true"
import script from "./DownLoadButton.vue?vue&type=script&lang=js"
export * from "./DownLoadButton.vue?vue&type=script&lang=js"
import style0 from "./DownLoadButton.vue?vue&type=style&index=0&id=278aa863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278aa863",
  null
  
)

export default component.exports